import script from "./UploadFileModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFileModal.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFileModal.vue?vue&type=style&index=0&id=45c80fb3&lang=scss"
import "./UploadFileModal.vue?vue&type=style&index=1&id=45c80fb3&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c80fb3"]])

export default __exports__